import {UserForm as _UserForm} from "./user.form";
import {UserFormButton} from "./user.form.button";

export const UserForm = {
    Form: _UserForm,
    Button: UserFormButton,
}
